module.exports = __webpack_public_path__ + "img/1 (117).7155b313.png";